import * as React from "react";
import { Paragraph } from "scuid-x";
import { GenErrorPage } from "../components/GenErrorPage";
import { Routes } from "../constants/Routing";

export const LoggedOut: React.SFC<any> = () => {
  // we assume that if there was no uuid that they were trying to come in through mobile and were logged out.
  const description = (
    <Paragraph>
      It appears that your are not logged in. Please return to
      your <a href={Routes.BORROWER_HREF} target="_self">application</a> and try again.
    </Paragraph>
  );

  return (
    <GenErrorPage
      title="Login Required"
      description={description}
    />
  );
};



// WEBPACK FOOTER //
// ./src/screens/LoggedOut.tsx